import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractAutoGroundButtonComponent } from '../abstract-auto-ground-button';

@Component({
  selector: 'h3-auto-ground-button',
  templateUrl: './auto-ground-button.component.html',
  styleUrl: './auto-ground-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AutoGroundButtonComponent extends AbstractAutoGroundButtonComponent {}
